import React from 'react';
import { Spin } from 'antd';

interface LoaddingProps {
  title?: string;
  subtitle?: string;
}

const Loadding: React.FC<LoaddingProps> = ({ 
  title = "PHẦN MỀM KHO", 
  subtitle = "Đang tải dữ liệu..." 
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      color: '#2c3e50'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '16px',
        padding: '32px',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.6)',
        maxWidth: '320px',
        width: '90%'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          margin: '0 auto 16px',
          background: 'rgba(52, 152, 219, 0.1)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Spin size="large" style={{ color: '#3498db' }} />
        </div>
        <h2 style={{ 
          margin: '0 0 8px 0', 
          fontSize: '20px', 
          fontWeight: 500,
          color: '#2c3e50'
        }}>
          {title}
        </h2>
        <p style={{ 
          margin: '0', 
          fontSize: '14px', 
          opacity: '0.7',
          fontWeight: 400,
          color: '#7f8c8d'
        }}>
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default Loadding;
